<template>
<div class="cont">
  <div class="container">
    <div :class="{list:true,lister:listshow}">
      <span class="title">
        {{cont.CONT_TITLE}}
      </span>
      <div class="text">
        {{cont.CONT_TEXT}}
      </div>
      <!-- <div class="corner">
      </div> -->
    </div>
      <div class="container-item">
        <div :class="{itemo:true,itemoer:itemoershow}">
          <a class="span1" target="_blank" href="/#/abouts" rel="nofollow">
            <div class="itemo-color">
              <div class="one" style="background-image:linear-gradient(180deg, #0083da, #7fccfd);">{{cont.CONT_ONE}}</div>
              <!-- <div class="one" style="background-image:linear-gradient(135deg, #568eef, #499bf1, #2cb7fa, #1ec3fd);">{{cont.CONT_ONE}}</div> -->
              <div>
                <div class="icon" style="width:100%;height:auto;text-align:center;">
                  <img class="img" style="border-radius:45px;" :src="cont.CONT_IMG" />
                </div>
                <div class="two">
                <p>
                  {{cont.CONT_TWO}}
                </p>
                </div>
                <div class="button">{{cont.CONT_BUTTON}}</div>
              </div>
            </div>
          </a>
        </div>
        <div :class="{itemo:true,itemoer:itemoershow}">
          <a class="span2" target="_blank" href="/#/abouts" rel="nofollow">
            <div class="itemo-color">
              <div class="one" style="background-image:linear-gradient(0deg, #7fccfd, #0083da);">{{cont.CONT_ONE2}}</div>
              <!-- <div class="one" style="background-image:linear-gradient(135deg, #64c17b, #59c58b, #45ceaa, #38d4bf);">{{cont.CONT_ONE2}}</div> -->
              <div>
                <div class="icon" style="width:100%;height:auto;text-align:center;">
                  <img class="img" style="border-radius:45px;" :src="cont.CONT_IMG2" />
                </div>
                <div class="two">
                <p>
                  {{cont.CONT_TWO2}}
                </p>
                </div>
                <div class="button">{{cont.CONT_BUTTON}}</div>
              </div>
            </div>
          </a>
        </div>
        <div :class="{itemo:true,itemoer:itemoershow}">
          <a class="span3" target="_blank" href="/#/abouts" rel="nofollow">
            <div class="itemo-color">
              <div class="one" style="background-image:linear-gradient(180deg, #0083da, #7fccfd);">{{cont.CONT_ONE3}}</div>
              <!-- <div class="one" style="background-image:linear-gradient(135deg, #ff406c, #fd6d6d, #fba16f, #f9ce70);">{{cont.CONT_ONE3}}</div> -->
              <div>
                <div class="icon" style="width:100%;height:auto;text-align:center;">
                  <img class="img" style="border-radius:45px;" :src="cont.CONT_IMG3" />
                </div>
                <div class="two">
                <p>
                  {{cont.CONT_TWO3}}
                </p>
                </div>
                <div class="button">{{cont.CONT_BUTTON}}</div>
              </div>
            </div>
          </a>
        </div>
        <div :class="{itemo:true,itemoer:itemoershow}">
          <a class="span1" target="_blank" href="/#/abouts" rel="nofollow">
            <div class="itemo-color">
              <div class="one" style="background-image:linear-gradient(0deg, #7fccfd, #0083da);">{{cont.CONT_ONE4}}</div>
              <!-- <div class="one" style="background-image:linear-gradient(135deg, #bba701, #d5fe48);">{{cont.CONT_ONE4}}</div> -->
              <div>
                <div class="icon" style="width:100%;height:auto;text-align:center;">
                  <img class="img" style="border-radius:45px;" :src="cont.CONT_IMG4" />
                </div>
                <div class="two">
                <p>
                  {{cont.CONT_TWO}}
                </p>
                </div>
                <div class="button">{{cont.CONT_BUTTON}}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      itemoershow: false,
      listshow: false,
      cont: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.cont = response.data.CONT
        // console.log(this.cont)
      })
  },
  methods: {
    handleScroll () {
      // console.log(this.currentScroll)
      // this.currentScroll = window.innerHeight
      this.currentScroll = window.pageYOffset
      // console.log(window.pageYOffset, this.currentScroll)
      if (this.currentScroll >= 400) {
        // console.log(this.currentScroll)
        this.itemoershow = true
      }
      if (this.currentScroll >= 300) {
        this.listshow = true
      }
    }
  }
  // },
  // methods: {
  //   more: function (event) {
  //     window.location.href = '#/scope'
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import url('../../static/less/less.css');
//>1100
// @keyframes FadeDown {
//   from {top: -40px;}
//   to {top: 0px;}
// }
@media only screen and (min-width: 960px) {
  .container-item {
    // display: block;
    display: flex;
    justify-content: space-between;
  }
  .itemo {
    width: 24%;
    height: 380px;
    .one {
      height: 155px;
      font-size: 24px;
    }
    .icon {
      margin-top: -45px;
    }
    .img {
      height:90px;
      width:90px;
    }
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .container-item {
    // display: block;
    display: flex;
    justify-content: space-between;
  }
  .itemo {
    width: 24%;
    height: 350px;
    // float: left;
    // margin-right: 20px;
    .one {
      height: 130px;
      font-size: 22px;
    }
    .icon {
      margin-top: -35px;
    }
    .img {
      height:75px;
      width:75px;
    }
  }
}
//<1100
@media only screen and (max-width: 767px) {
  .container-item {
    display: block;
    // display: flex;
    // justify-content: space-between;
  }
  .itemo {
    width: 100%;
    height: 380px;
    // float: left;
    // margin-right: 20px;
    .one {
      height: 155px;
      font-size: 24px;
    }
    .icon {
      margin-top: -45px;
    }
    .img {
      height:90px;
      width:90px;
    }
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #2ec4b6;
}
.cont {
  text-align: center;
  padding-top: 80px;
  display: flex;
  // min-width: 1200px;
}
.demo {
  text-align: center;
  margin: 20px;
}
.buttondemo {
  background-color: #2ec4b6;
  width: 120px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: #fdfffc;
}
.container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: FadeDown;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    // position: relative;
    // animation-name: FadeDown;
    // animation-duration: 1.5s;
    opacity: 0;
    text-align: center;
    margin-bottom: 30px;
    .title {
      font-size: 27px;
      color: #333;
    }
    .text {
      color: #818181;
    }
  }
  .corner {
    // padding-top: 10px;
    margin: 15px auto;
    width: 0;
    height: 0;
    border: 10px solid #ff9f1c;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  &-item {
    // margin: 0px 5%;
    clear: both;
    width: 100%;
    height: auto;
    margin-top: 40px;
    // display: flex;
    // justify-content: space-between;
    .itemoer {
      transform: translateY(0%) !important;
      opacity: 1 !important;
      transition: all 2s ease;
    }
    .itemo {
      transform: translateY(-20%);
      opacity: 0;
      // margin-top: 20px;
      // width: 350px;
      // height: 380px;
      // float: left;
      margin-top: 20px;
      position: relative;
      // transition: all 0.3s;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
      text-align: center;
      a {
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: 0.3s all;
        // transition: none;
        // color: #333;
      }
      .span1:hover {
        border: 1px solid #26bbfb;
        box-shadow: 0px 0px 8px #26bbfb;
      }
      .span2:hover {
        border: 1px solid #26bbfb;
        box-shadow: 0px 0px 8px #26bbfb;
      }
      .span3:hover {
        border: 1px solid #26bbfb;
        box-shadow: 0px 0px 8px #26bbfb;
      }
      // .span2:hover {
      //   border: 1px solid #49cda4;
      //   box-shadow: 0px 0px 8px #49cda4;
      // }
      // .span3:hover {
      //   border: 1px solid #fe496b;
      //   box-shadow: 0px 0px 8px #fe496b;
      // }
      // a:hover {
      //   border: 1px solid #26bbfb;
      //   box-shadow: 0px 0px 8px;
      // }
      .itemo-color {
        .one {
          background-image: linear-gradient(135deg, #568eef, #499bf1, #2cb7fa, #1ec3fd);
        }
        // background-color: #eee;
      }
      .one {
        width: 100%;
        // height: 155px;
        background: rgba(116, 116, 156, 1.7);
        // background-size: cover;
        // background-position: center;
        padding-top: 45px;
        // font-size: 24px;
        color: #fff;
        text-align: center;
        box-sizing: border-box;
      }
      .two {
        font-size: 14px;
        line-height: 24px;
        height: 82px;
        color: #011627;
        padding: 10px 10% 10px 10%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        word-break: break-word;
        // background-color: lavender;
      }
      .button {
        font-size: 14px;
        // padding: 10px 0 10px 0;
        display: block;
        width: 105px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 15px;
        background: #26bbfb;
        margin: 0 auto;
        margin-top: 20px;
        // font-size: 13px;
        // margin-top: 30px;
        // background-color: lavender;
        // padding: 10px 0 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cont.vue